import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import styled from 'styled-components';
export var BadgeLocation = function (BadgeLocation) {
  BadgeLocation[BadgeLocation["TopRight"] = 1] = "TopRight";
  BadgeLocation[BadgeLocation["TopLeft"] = 2] = "TopLeft";
  BadgeLocation[BadgeLocation["BottomRight"] = 3] = "BottomRight";
  BadgeLocation[BadgeLocation["BottomLeft"] = 4] = "BottomLeft";
  return BadgeLocation;
}({});
export var Badge = styled.div.attrs(props => {
  return _objectSpread(_objectSpread({}, props), {}, {
    className: props.className
  });
}).withConfig({
  displayName: "Badge",
  componentId: "sc-1mmrkg7-0"
})(["", " position:absolute;background-color:white;border:1px solid black;border-radius:50%;text-align:center;white-space:nowrap;font-size:12px;width:", " height:", " line-height:32px;z-index:2;"], props => {
  if (props.location === BadgeLocation.TopRight) {
    return `top: ${props.offset}px; right: ${props.offset}px;`;
  } else if (props.location === BadgeLocation.TopLeft) {
    return `top: ${props.offset}px; left: ${props.offset}px;`;
  } else if (props.location === BadgeLocation.BottomRight) {
    return `bottom: ${props.offset}px; right: ${props.offset}px;`;
  } else if (props.location === BadgeLocation.BottomLeft) {
    return `bottom: ${props.offset}px; left: ${props.offset}px;`;
  } else {
    return '';
  }
}, props => `${props.size}px;`, props => `${props.size}px;`);